const state = {
  treelist: '', // 保存整个结构树
  currentNode: { // 当前选中的节点
    id: '',
    upOrg: ''
  }
}

const getters = {
  getCurrentNodeId () {
    return state.currentNode.id
  },

  getTreeList () {
    return state.treelist
  }
}
// const actions = {
// };

const mutations = {
  setTreeListData (state, obj) {
    state.treelist = JSON.parse(JSON.stringify(obj))
  },

  setCurrnetNodeInfo (state, obj) {
    if (state.currentNode.id !== obj.id) {
      state.currentNode.id = obj.id
      state.currentNode.upOrg = obj.upOrg
    }
  }
}

export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/tree.js